import {
  BottomText,
  BottomTitles,
  Container,
  GreyBar,
  IterableBottom,
  IterableSubTitle,
  IterableTitle,
  IterableTitleSlot,
  IterableData,
  Warning,
  LastData,
} from "./styles";
import ProgressBar from "./ProgressBar";

const DelayedFlowIterable = ({
  onClick = null,
  title, //string
  description, //string
  client, //string
  flowDelta = "MIA", // Number of delays or aceleration on the critical path
  LastUpdate = "- -",
}) => {
  return (
    <>
      <Container onClick={onClick}>
        <IterableTitleSlot>
          <IterableTitle>{title}</IterableTitle>
        </IterableTitleSlot>
        <IterableSubTitle>{description}</IterableSubTitle>
        <GreyBar />
        <IterableBottom>
          <IterableData width={"30%"}>
            <BottomTitles>Cliente</BottomTitles>
            <BottomText>{client}</BottomText>
          </IterableData>
          <IterableData width={"30%"}>
            <BottomTitles>Atraso do Fluxo</BottomTitles>
            <BottomText>{flowDelta} </BottomText>
          </IterableData>
          <LastData width={"40%"}>
            <BottomTitles>Ultima Atualização</BottomTitles>
            <BottomText>{LastUpdate}</BottomText>
          </LastData>
        </IterableBottom>
      </Container>
    </>
  );
};

export default DelayedFlowIterable;
